<template>
  <div>
    <div style="float: left;width: 80%;">
      <div class="pointer aling_center">
        <img
          v-if="info.platform_code"
          :src="require('@/assets/img/platform/pla_'+info.platform_code+'.png')"
          alt
          class="edit_icon"
        />
        <span>{{info.shopname}}({{info.reportid}})</span>
      </div>
      <div class='ellipsis' style="width:80%;">
        <a
          :href="info.reporturl"
          class="common_href"
          target="view_window"
        >{{info.reporturl}}</a>
      </div>
      <div>产品信息:{{info.productinfo}}</div>
      <div v-if="reportTime">举报时间: {{info.createtime | fullTime}}</div>
    </div>

    <div style="padding-top: 34px;width: 20%;float: left;" v-if="info.isRepeat == true">
      <div class="repeatStyle">
        疑似重复项
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      require: true
    },
    reportTime: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
.repeatStyle {
  padding: 0px 8px;
  font-size: 13px;
  background-color: red;
  color: white;
  float: left;
  border-radius: 6px;
}
</style>
